/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteDevicePlanChangeRequest
 */
export interface DeleteDevicePlanChangeRequest {
    /**
     * 
     * @type {string}
     * @memberof DeleteDevicePlanChangeRequest
     */
    id: string;
}

/**
 * Check if a given object implements the DeleteDevicePlanChangeRequest interface.
 */
export function instanceOfDeleteDevicePlanChangeRequest(value: object): value is DeleteDevicePlanChangeRequest {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function DeleteDevicePlanChangeRequestFromJSON(json: any): DeleteDevicePlanChangeRequest {
    return DeleteDevicePlanChangeRequestFromJSONTyped(json, false);
}

export function DeleteDevicePlanChangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteDevicePlanChangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function DeleteDevicePlanChangeRequestToJSON(json: any): DeleteDevicePlanChangeRequest {
    return DeleteDevicePlanChangeRequestToJSONTyped(json, false);
}

export function DeleteDevicePlanChangeRequestToJSONTyped(value?: DeleteDevicePlanChangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

